// extracted by mini-css-extract-plugin
export default {"blocks":"ClientSubscriptions_blocks__VXw93"};